import useReactHookForm from "hooks/useReactHookForm";
import { Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import {
  chapterInitialValues,
  chapterValidationSchema,
  chapterPropertiesUpdate,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useLazyQuery } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";

import { getQueryParam, isEmpty } from "utils/helpers";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { GET_CHAPTER_LIST } from "utils/graphql/services/global-content-hierarchy/queries";

export const ChapterUpdate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    chapterInitialValues,
    chapterValidationSchema,
    ""
  );
  const [getchapterList, { loading, error, data }] = useLazyQuery(
    GET_CHAPTER_LIST,
    {
      client: entitesClient,
      fetchPolicy: "no-cache",
    }
  );

  const location = useLocation();
  const id = getQueryParam("id", location);
  const status = getQueryParam("status", location);

  useEffect(() => {
    if (!isEmpty(data?.getChapters?.records)) {
      const chapter = data?.getChapters?.records?.[0];
      if (!isEmpty(chapter)) {
        setValue("global_name", chapter?.global_name);
        setValue("gcf_public_chapter_id", chapter?.gcf_public_chapter_id);
        setValue("status", chapter?.status);
        setValue("color_icon_url", chapter?.color_icon_url);
        setValue("patch_icon_url", chapter?.patch_icon_url);
        setValue("chapter_code", chapter?.chapter_code);
        setValue("image_url", chapter?.image_url);
        setValue("gcf_learn_chapter_id", chapter?.gcf_learn_chapter_id);
        setValue("gcf_learn_chapter_name", chapter?.gcf_learn_chapter_name);
        setValue("gcf_public_chapter_name", chapter?.gcf_public_chapter_name);
        setValue(
          "npractice_public_chapter_id",
          chapter?.npractice_public_chapter_id
        );
        setValue(
          "npractice_public_chapter_name",
          chapter?.npractice_public_chapter_name
        );
        setValue(
          "npractice_practice_chapter_id",
          chapter?.npractice_practice_chapter_id
        );
        setValue(
          "npractice_practice_chapter_name",
          chapter?.npractice_practice_chapter_name
        );
      }
    }
  }, [data]);

  useEffect(() => {
    getchapterList({
      variables: {
        filter: {
          id: +id,
          status,
        },
      },
    });
  }, []);

  if (loading) {
    return <p>loading......</p>;
  }

  return (
    <div>
      <TypographyHeading>Chapter</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={chapterPropertiesUpdate}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>
      </Paper>
    </div>
  );
};
